import ChatMessage from "./chatMessage";

export default function InstructionsBubble({ apiRoot, problemName }) {
    const instructionsText = `
### Instructions
Welcome to your **AI-assisted mock interview**!

This interview will consist of **six different phases**:

1. **Problem Statement**: I'll share a problem statement with you.
2. **Clarifying Questions**: You'll ask me some clarifying questions to better understand the problem.
    - This helps me evaluate your ability to handle ambiguity.
3. **Guiding Questions**: I'll evaluate your Data Structures and Algorithms knowledge by asking you some guiding questions.
4. **Implementation**: You'll write code to solve the problem.
5. **Test Cases**: You'll write test cases to test your code.
    - This helps me evaluate your ability to anticipate edge cases.
6. **Evaluation**: I'll share my evaluation with you and give you additional feedback.
    - My evaluations may not be perfect!
    - However, they should provide you with an idea of your strengths and weaknesses.

### Ready?
Let's get started!
    `;
    return (
        <ChatMessage variant="system" isUser={false}>
            {instructionsText}
        </ChatMessage>
    );
}